import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=851a6dfc&scoped=true"
import script from "./contact-us.vue?vue&type=script&lang=js"
export * from "./contact-us.vue?vue&type=script&lang=js"
import style0 from "./contact-us.vue?vue&type=style&index=0&id=851a6dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851a6dfc",
  null
  
)

export default component.exports